import { LifeBuoy } from "lucide-react";

/**
 * Full-width contact/support strip.
 * - Uses the FreelanZen brand green (`bg-zen-primary`) so it stays in sync with the
 *   Zen wordmark, primary buttons ("Prova gratis"), and active sidebar states.
 * - Not sticky/fixed: it just appears at the end of the scrollable content so it
 *   never overlaps the mobile bottom tab bar.
 *
 * Prop `variant`:
 *  - "app"   → adds mobile bottom-padding so it clears the fixed mobile tab bar
 *  - "site"  → sits directly above the marketing footer, no mobile tab bar to clear
 */
export default function SupportBanner({ variant = "app" }) {
  const wrapperClass = variant === "app"
    ? "mt-10 pb-16 md:pb-0"
    : "mt-0";

  return (
    <div data-testid="support-banner-wrapper" className={wrapperClass}>
      <div
        data-testid="support-banner"
        className="w-full bg-zen-primary text-white"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 text-center text-sm">
          <LifeBuoy size={16} strokeWidth={1.8} className="shrink-0"/>
          <span>
            Serve una mano? Scrivici a{" "}
            <a
              data-testid="support-banner-email"
              href="mailto:customer.service@freelanzen.it"
              className="font-medium underline underline-offset-4 decoration-white/50 hover:decoration-white transition-colors"
            >
              customer.service@freelanzen.it
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}
